import React from 'react';

import styles from './upgradeToPerformanceHs.scss';

const UpgradeToPerformanceHsButton = props => {
    const { onClick } = props;
    return (
        <button
            type="button"
            className={`btn btn-primary btn-md text-uppercase ${styles.primaryActionButton}`}
            onClick={onClick}
        >
            Upgrade to Performance High School
        </button>
    );
};

export default UpgradeToPerformanceHsButton;
